export const componentNameKey = 'CookieConsent_Dataset_Component_VideoPlayer';
export const componentNameDefault = 'Video Player';
